"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductAdd = void 0;
const Base_1 = require("./Base");
exports.PostProductAdd = {
    url: Base_1.URL_BASE + "/ProductAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductAdd.js.map